<kendo-label [for]="for" [text]="text" [ngClass]="[fontClass, showErrors ? 'show-errors': '']" [optional]="optional" kendoTooltip [title]="tooltipText" [tooltipWidth]="tooltipWidth">
    
</kendo-label>
